<template>
  <a :class="type" class="social-sharing__item" @click="share">
    <b-icon v-if="!iconShow" :icon="type" />
    <img v-else :src="icon" alt="" />
    <span v-if="labelShow">{{ label }}</span>
  </a>
</template>
<script>
export default {
  name: 'SocialSharing',
  props: {
    type: {
      type: String,
      default: 'email'
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    subject: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    hashtags: {
      type: String,
      default: ''
    },
    via: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  computed: {
    labelShow: function() {
      return this.label && this.label !== '';
    },
    iconShow: function() {
      return this.icon && this.icon !== '';
    },
    hasContent: function() {
      return this.content && this.content !== '';
    },
    hasHashtags: function() {
      return this.hashtags && this.hashtags !== '';
    },
    hasVia: function() {
      return this.via && this.via !== '';
    }
  },
  methods: {
    share() {
      const width = 575;
      const height = 400;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;
      const options = `status=1,width=${width},height=${height},top=${top},left=${left}`;
      const location = this.url !== '' ? this.url : document.location.protocol + '//' + document.location.host;
      const link = encodeURIComponent(location);
      const message = this.content;

      let url = '';
      switch (this.type) {
        case 'twitter':
          const twHashtags = this.hasHashtags ? `&hashtags=${this.hashtags}` : '';
          const twVia = this.hasVia ? `&via=${this.via}` : '';
          url = `https://twitter.com/share?url=${link}&text=${message}${twHashtags}${twVia}`;
          break;

        case 'facebook':
          const FBHashtags = this.hasHashtags ? `&hashtag=%23${this.hashtags}` : '';
          const FBQuote = this.hasContent ? `&quote=${this.content}` : '';
          url = `https://facebook.com/sharer/sharer.php?u=${link}${FBHashtags}${FBQuote}`;
          break;

        case 'google':
          url = `https://plus.google.com/share?url=${link}`;
          break;

        case 'tumblr':
          url = `http://tumblr.com/widgets/share/tool?canonicalUrl=${link}`;
          break;

        case 'reddit':
          url = `https://reddit.com/submit/?url=${link}`;
          break;

        case 'whatsapp':
          url = `whatsapp://send?text=${message}%20${link}`;
          break;

        case 'telegram':
          url = `https://telegram.me/share/url?url=${link}&text=${message}`;
          break;

        case 'vk':
          url = `http://vk.com/share.php?url=${link}&title=${message}`;
          break;

        case 'hackernews':
          url = `https://news.ycombinator.com/submitlink?u=${link}&t=${message}`;
          break;

        case 'xing':
          url = `https://www.xing.com/app/user?op=share;url=${link};title=${message}`;
          break;

        case 'linkedin':
          url = `https://www.linkedin.com/shareArticle?mini=true&url=${link}&title=${message}&summary=${message}&source=${link}`;
          break;

        case 'instagram':
          url = `https://www.instagram.com/${this.via}`;
          break;

        default:
          url = `mailto:?subject=${encodeURIComponent(this.subject || '')}&body=${encodeURIComponent(
            (this.content && `${this.content}\n\n${location}`) || location
          )}`;
          break;
      }

      if (this.type === 'email' || this.type === 'instagram') {
        window.location.href = url;
      } else {
        window.open(url, '', options);
      }
    }
  }
};
</script>
